@import 'styles/blaze/mixins';
@import 'styles/mixins';

.wrapper {
  @include blur(10px);
  @include transition;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 1px;
  padding: 5px;
  background: var(--editor-top);
  width: 100%;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.05);
  z-index: 1;
}

[data-color-scheme='light'] {
  .wrapper {
    background: #fff;
    box-shadow: none;
  }
}

.left {
  display: flex;
  gap: 5px;
}

.center {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 0;
  width: 100%;
}

.right {
  display: flex;
  align-items: center;
  gap: 2px;
  margin-left: auto;
}
